export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Final (2)_01.6bb00de9.jpg";